import { watchEffect, reactive, toRefs } from "vue";
import apis from "@/api";
export default {
  name: "OfferRefDemandDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    offerIds: {
      type: String
    },
    neSrcId: {
      type: String
    }
  },
  setup(props, context) {
    let data = reactive({
      auditTip: ["驳回", "待审核", "通过", "保留意见"],
      loading: false,
      paginationObj: {
        total: 0,
        size: 10,
        current: 1
      },
      tableData: []
    });
    const close = () => {
      context.emit('update:visible', false);
    };
    const tableRowClassName = (row, rowIndex) => {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    };
    const getPage = () => {
      apis.getSmsPageOfOfferIds({
        ...data.paginationObj,
        offerIds: props.offerIds.join(','),
        neSrcId: props.neSrcId
      }).then(res => {
        if (res.success) {
          data.tableData = res.data.records;
        }
      });
    };
    const handleSizeChange = val => {
      console.log(`每页 ${val} 条`);
      data.paginationObj.size = val;
      getPage();
    };
    const handleCurrentChange = val => {
      console.log(`当前页: ${val}`);
      data.paginationObj.current = val;
      getPage();
    };
    watchEffect(() => {
      if (props.offerIds) {
        getPage();
      }
    });
    return {
      ...toRefs(data),
      close,
      tableRowClassName,
      handleCurrentChange,
      handleSizeChange
    };
  }
};